import PropTypes from 'prop-types';
import { React, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import { Box, Stack, Container } from '@mui/system';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { titleHeadingStyle, titleHeadingStyleSmole } from 'src/pages/style';

import ActionButton from 'src/components/action-button/action-button';

ActionBar.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
  downloadName: PropTypes.string,
};

export default function ActionBar({ title, href, downloadName }) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const [isDownloadDebouncing, setIsDownloadDebouncing] = useState(false);

  const handleDownloadClick = () => {
    if (!isDownloadDebouncing) {
      setIsDownloadDebouncing(true);
      setTimeout(() => {
        setIsDownloadDebouncing(false);
      }, 1500);
    }
  };

  return (
    <Box
      bgcolor="white"
      width="100%"
      paddingX="20px"
      paddingY="20px"
      borderRadius="12px"
      boxShadow="0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)"
      height="100px"
    >
      <Container sx={{ height: '100%' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ height: '100%' }}
        >
          <Typography
            style={isSmallScreen ? titleHeadingStyleSmole : titleHeadingStyle}
            mx={1}
          >
            {title}
          </Typography>

          <ActionButton
            id="download-users-btn"
            href={href}
            download={downloadName}
            disabled={isDownloadDebouncing}
            onClick={handleDownloadClick}
            text={t('buttons.exportToCsv')}
            title={t('buttons.downexportToCsvload')}
            icon={isSmallScreen ? 'material-symbols:download' : 'eva:download-fill'}
            sx={{ mx: 1 }}
          />
        </Stack>
      </Container>
    </Box>
  );
}
